import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue';

export const calculatePercentageValues = (initialValue: number, forwardedValue: number) => {
  if (initialValue === 0) {
    return {
      discardedPercentage: '100%',
      discardedValueNumeric: forwardedValue ?? 0,
      forwardedPercentage: '0%',
      isCurrentStepForwardingValue: false,
    };
  }

  const discardedValue = initialValue - forwardedValue;
  const discardedPercentage = (discardedValue / initialValue) * 100;
  const forwardedPercentage = (forwardedValue / initialValue) * 100;

  if (discardedPercentage > 0 && discardedPercentage < 0.01) {
    return {
      discardedPercentage: '<0.01%',
      discardedValueNumeric: discardedValue,
      forwardedPercentage: '>99.99%',
      isCurrentStepForwardingValue: true,
    };
  }

  if (forwardedPercentage > 0 && forwardedPercentage < 0.01) {
    return {
      discardedPercentage: '>99.99%',
      discardedValueNumeric: discardedValue,
      forwardedPercentage: '<0.01%',
      isCurrentStepForwardingValue: true,
    };
  }

  return {
    discardedPercentage: `${abbreviateNumericValue(discardedPercentage, { allowZero: true })}%`,
    discardedValueNumeric: discardedValue,
    forwardedPercentage: `${abbreviateNumericValue(forwardedPercentage, { allowZero: true })}%`,
    isCurrentStepForwardingValue: initialValue > discardedValue,
  };
};
